import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const parseJwt = (token) => {
    try {
        return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
        return null;
    }
}

export const PrivateRoute = () => {
    const user = localStorage.getItem("auth_token")
    
    if (user) {
        const decodedJwt = parseJwt(user)
        return (decodedJwt.exp * 1000 > Date.now()) ? <Outlet /> : <Navigate to="/auth/signin" />
    }else{
        <Navigate to="/auth/signin" />
    }
}